<section class="dialog_header_">
  <mat-icon>warning</mat-icon>
  <button mat-icon-button color="primary" class="closeDialogBtn" (click)="closeDialog()"><mat-icon>close</mat-icon></button>
</section>
<section class="dialoag_body_">
  <div class="error_img__">
    <img *ngIf="data === 'No User Found'" src="../../../../../../assets/belairtrip_assets/svg_icon/email_already.png" alt="Login Error" class="img-fluid">
    <img *ngIf="data === 'Email already exist'" src="../../../../../assets/belairtrip_assets/svg_icon/email_already.png" alt="Login Error" class="img-fluid">
  </div>
  <div class="">
    <p>
      <ng-container *ngIf="data === 'No User Found'"> <span class="txt-color">Please enter a valid email ID and password.<br>or<br></span><a (click)="forgetpassword()">Reset Password</a></ng-container>
      <ng-container *ngIf="data === 'Validation Failed'">OOPS! This Email Address already taken Please <span><a routerLink="/forgot-password" routerLinkActive="router-link-active" >Forgot forgot Password</a></span></ng-container>
      <ng-container *ngIf="data === 'Email already exist'">This Email Address already exist.</ng-container>
    </p>
  </div>
  <!-- <button mat-button class="secoundaryBtn">Close</button> -->
</section>
